import { Card } from 'antd';

export default function HomeCard({ children, ...props }) {
  const styles = {
    cardStyle: {
      borderRadius: 12,
      boxShadow: '0 1px 4px rgba(0, 0, 0, 0.06)',
      height: '100%'
    },
    titleStyle: {
      fontWeight: 'bold'
    }
  };
  return (
    <Card headStyle={styles.titleStyle} style={styles.cardStyle} {...props}>
      {children}
    </Card>
  );
}
